<template>
  <div class="chat-container">
    <!-- 欢迎屏幕 -->
    <div v-if="showWelcome" class="welcome-screen">
      <h2>欢迎开始面试</h2>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>请确保您的设备已连接麦克风并打开</p>
      <p>&nbsp;</p>
      <!-- <p>每次回答不得超过20秒</p> -->
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <el-button type="primary" @click="startInterview" style="position:relative;z-index:3">开始面试</el-button>
      <div style="position:fixed;left:0;width:100%;height:30vh;bottom:0;z-index:2;background:#fff"></div>
    </div>
    <!-- 对话区域 -->
    <div v-else-if="showRes">
      <InterviewRecord :view="resView" :view_item="resItem" />
    </div>
    <div v-else class="chat-main">
      <!-- 消息列表区域 -->
      <!-- {{ showAudioSrc }} -->
      <audio :src="showAudioSrc" preload   controls
        @ended="overFunc" id="audioPlayer"
       style="display: none;"></audio>
      <div class="chat-history">
        <el-scrollbar ref="scrollbarRef">
          <div class="chat-messages">
            <!-- 系统消息气泡 -->
            <div class="message-bubble system-message">
               可以开始了吗？
            </div>

            <div v-for="chat,i in allChat" :key="'chat'+i"
                :class="`message-bubble ${chat.role === 'user' ? 'user-message' : 'system-message'}`"
            > 
              <div v-if="chat.role === 'user'">
                {{ chat.content }}
              </div>
                <type-writer v-else :text="chat.content"  @scroll="scrollToBottom" ></type-writer>
            </div>
            
            <div class="radar-charts-container" v-if="showRadarChart">
              <div class="radar-chart" id="radarChart"></div>
              <div class="radar-chart" id="performanceChart"></div>
            </div>
            <div style="height:30vh"> </div>
          </div>
        </el-scrollbar>
      </div>
      
      <!-- 底部录音区域 -->
      <div class="chat-input">
        <div v-if="isFinish">
          面试已结束
        </div>
        <div v-else>
          <div v-if="isOver">
            <div>请在此等待面试结果</div>

            <div class="audio-playing-indicator">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
          </div>
          <div v-else>

            <div v-if="isPlaying" class="audio-playing-indicator">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            <div class="voice-input-container" v-else>
              <!-- <el-button

                type="primary"
                circle
                class="voice-button"
                v-if="micPermissionGranted"
                @mousedown="startRecording"
                @mouseup="stopRecording"
                @mouseleave="stopRecording"
                @touchstart.prevent="startRecording"
                @touchend.prevent="stopRecording"
                @touchcancel.prevent="stopRecording"
              >
              <el-icon><Microphone /></el-icon>
              </el-button>
              <div class="voice-hint">{{ !micPermissionGranted ? '请允许麦克风权限' : (recording ? '松开发送' : '按住说话') }}</div>
               -->
              <div v-if="recording" class="recording-time" style="text-align:center;">
                <div >录音中</div>
                <div>{{ recordingTime }}</div>
                <!-- <div> <el-button
                @mouseup="stopRecording"
                
                @touchend.prevent="stopRecording"
                      >回答完毕</el-button> </div>
                 -->
                </div>
            </div>

          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import * as echarts from 'echarts';
import { postData } from '@/api.js';
// import { Microphone } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import InterviewRecord from '@/components/InterviewRecord.vue';
import TypeWriter from '../components/TypeWriter.vue';


export default {
  name: 'ViewChat',
  components: {
    // Microphone,
    InterviewRecord,
    TypeWriter
  },
  setup() {
    const messages = ref({});
    const recording = ref(false);
    const currentRound = ref(1);
    const route = useRoute();
    const recordingTime = ref('01:30');
    let timerInterval = null;
    const wav1 = ref(null);
    const wav1Preview = ref(null);
    const showRes = ref(false);
    const resView = ref(null);
    const resItem = ref(null);
    const micPermissionGranted = ref(false);
    const showWelcome = ref(true);
    const isPlaying = ref(1);
    const allChat = ref([]);
    const isOver=ref(false)
    const isFinish=ref(false)
    const showRadarChart = ref(false)
    const showAudioSrc=ref(false)
    let emptyAudio=0
    let uuid = '';
    let radarChart = null;
    let chatData=null;
    const initRadarChart = (scoreData) => {
      // 生成随机评分（3-7之间的整数）
      const performanceScores = {
        流畅度: Math.floor(Math.random() * 5) + 3,
        清晰度: Math.floor(Math.random() * 5) + 3,
        表达自信度: Math.floor(Math.random() * 5) + 3,
        情绪稳定性: Math.floor(Math.random() * 5) + 3
      };

      // 初始化第一个雷达图
      const chartDom = document.getElementById('radarChart');
      if (!chartDom) return;
      
      radarChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '专业能力',
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        radar: {
          radius: '65%',
          axisName: {
            formatter: '{value}',
            fontSize: 12,
            padding: [0, 0, 0, 10]
          },
          indicator: [
            { name: '逻辑清晰度', max: 10 },
            { name: '思维深度', max: 10 },
            { name: '相关性', max: 10 },
            { name: '岗位匹配度', max: 10 },
            { name: '行业知识', max: 10 },
            { name: '案例支撑', max: 10 }
          ]
        },
        series: [{
          type: 'radar',
          data: [{
            value: [
              scoreData['逻辑清晰度'],
              scoreData['思维深度'],
              scoreData['相关性'],
              scoreData['岗位匹配度'],
              scoreData['行业知识'],
              scoreData['案例支撑']
            ],
            name: '面试评分',
            areaStyle: {
              color: 'rgba(64, 158, 255, 0.2)'
            },
            lineStyle: {
              color: '#409EFF'
            },
            itemStyle: {
              color: '#409EFF'
            }
          }]
        }]
      };
      radarChart.setOption(option);

      // 初始化第二个雷达图（表现评分）
      const performanceChartDom = document.getElementById('performanceChart');
      if (!performanceChartDom) return;
      
      const performanceChart = echarts.init(performanceChartDom);
      const performanceOption = {
        title: {
          text: '表达能力',
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        radar: {
          radius: '65%',
          axisName: {
            formatter: '{value}',
            fontSize: 12,
            padding: [0, 0, 0, 10]
          },
          indicator: [
            { name: '流畅度', max: 10 },
            { name: '清晰度', max: 10 },
            { name: '表达自信度', max: 10 },
            { name: '情绪稳定性', max: 10 }
          ]
        },
        series: [{
          type: 'radar',
          data: [{
            value: [
              performanceScores.流畅度,
              performanceScores.清晰度,
              performanceScores.表达自信度,
              performanceScores.情绪稳定性
            ],
            name: '表现评分',
            areaStyle: {
              color: 'rgba(255, 102, 0, 0.2)'
            },
            lineStyle: {
              color: '#ff6600'
            },
            itemStyle: {
              color: '#ff6600'
            }
          }]
        }]
      };
      performanceChart.setOption(performanceOption);
    };

    const scrollbarRef = ref(null);
    const scrollToBottom = () => {
      
      console.log('zzzscroll')
      // nextTick(() => {
        if (scrollbarRef.value) {
          console.log('vvvscroll')
          scrollbarRef.value.setScrollTop(scrollbarRef.value.wrapRef.scrollHeight);
        }
      // });
    };
    const showChat=()=>{
      showRadarChart.value = true;
            nextTick(() => {
              initRadarChart(chatData);

            });
    }
    // 开始对话
    const startInterview = async () => {

      
      try {
        await getPermission();
        if (micPermissionGranted.value) {
          showWelcome.value = false;
          
      // overDo();
          await fetchInterviewData("我准备好了。");
          overFunc();
        }
      } catch (error) {
        console.error('开始对话失败:', error);
      }
    };
    const overDo=async ()=>{
      let uuidx=uuid
      // uuidx='67be7d7698876'
      const rr=await postData(`chat_view_go_over`, {id:route.params.id,uuid:uuidx});
          if(rr){
            isFinish.value=true
            chatData=rr.data.score
            playSrc(rr.data.src)
            allChat.value.push({role:'assistant',content:'综评：'+rr.data.comment})
          }
    }
    const overFunc=async ()=>{
        scrollToBottom();
        if(isFinish.value){
            showChat();
            return
        }
        if(isOver.value){
            overDo();
            return
        }
        if(allChat.value[allChat.value.length-1].role==='assistant'){
            isPlaying.value=false
            setTimeout(()=>{
              startRecording();
            },1000)
        }else{
            const txt=allChat.value[allChat.value.length-1].content
            const id = route.params.id;

            const response = await postData(`chat_view_go`, {id,txt,uuid});
            if (response) {
                uuid=response.uuid
                allChat.value.push({role:'assistant',content:response.data})
                if(response.data=='对不起，我没有听清楚'){
                  emptyAudio++
                  if(emptyAudio>3){
                    location.reload()
                  }
                }else{
                  emptyAudio=0;
                }
                scrollToBottom();
                playSrc(response.src)
                //播放response.src
                if(response.isOver){
                  isOver.value=true
                  
                }
            }
        }
        
        
    }
    const playSrc=(src)=>{
      showAudioSrc.value=src
      nextTick(()=>{
                  let play=()=>{
                    console.log('play....')
                    const audio = document.getElementById('audioPlayer');
                    if (audio.currentTime > 0 && !audio.paused && !audio.ended) {
                      clearInterval(v)
                      } else {
                        audio.play()
                      }
                  }
                  let v=setInterval(()=>{
                    play()
                  },1000)
                  play()
                })
                
    }
    // 获取对话数据
     /* eslint-disable-next-line no-unused-vars */
    const fetchInterviewData = async (txt) => {
        isPlaying.value=true
        allChat.value.push({role:'user',content:txt})
    };

    const getPermission = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        micPermissionGranted.value = true;
      } catch (error) {
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          ElMessage.error('请允许访问麦克风权限');
        } else {
          ElMessage.error('无法访问麦克风，请检查设备连接');
        }
      }
    };

    let mediaRecorder = null;

    // 开始录音
    const startRecording = async () => {
      try {
        if (!window.AudioContext && !window.webkitAudioContext) {
          ElMessage.error('您的浏览器不支持录音功能，请使用最新版本的浏览器');
          return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          }
        });

        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const audioContext = new AudioContext();
        const mediaStreamSource = audioContext.createMediaStreamSource(stream);
        const recorder = audioContext.createScriptProcessor(4096, 1, 1);

        const audioChunks = [];
        let silentDuration = 0; // 静默持续时间（毫秒）
        const silenceThreshold = 0.01; // 静默音量阈值
        const maxSilentTime = 6000; // 最大静默时间（5秒）

        recorder.onaudioprocess = (e) => {
          const audioData = e.inputBuffer.getChannelData(0);
          audioChunks.push(new Float32Array(audioData));

          // 计算音量
          const volume = Math.sqrt(audioData.reduce((sum, val) => sum + val * val, 0) / audioData.length);

          // 静默检测逻辑
          if (volume < silenceThreshold) {
            // 根据 onaudioprocess 触发频率调整静默时间增量
            // 当前触发频率约为 10.77 次/秒，每次增量约为 1000ms / 10.77 ≈ 93ms
            silentDuration += 93; 
          } else {
            silentDuration = 0; // 重置静默计时
          }
          console.log('静默时间：', silentDuration);

          // 如果静默时间超过5秒，停止录音
          if (silentDuration >= maxSilentTime) {
            stopRecording();
          }
        };

        mediaStreamSource.connect(recorder);
        recorder.connect(audioContext.destination);

        recording.value = true;

        let startTime = Date.now();
        timerInterval = setInterval(() => {
          const elapsedTime = Date.now() - startTime;
          const remainingSeconds = Math.max(0, 90 - Math.floor(elapsedTime / 1000));
          // recordingTime.value = `00:${remainingSeconds.toString().padStart(2, '0')}`;
          
          const minutes = Math.floor(remainingSeconds / 60);
          const seconds = Math.floor((remainingSeconds % 60) );
          recordingTime.value = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
          
          if (remainingSeconds === 0) {
            stopRecording();
          }
        }, 1000);

        mediaRecorder = {
          stream,
          audioContext,
          recorder,
          mediaStreamSource,
          audioChunks
        };
      } catch (error) {
        console.error('录音失败:', error);
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          ElMessage.error('请允许访问麦克风权限');
        } else {
          ElMessage.error('录音失败，请检查设备连接并重试');
        }
        throw error;
      }
    };

    // 停止录音
    const stopRecording = () => {
      if (recording.value && mediaRecorder) {
        recording.value = false;

        if (timerInterval) {
          clearInterval(timerInterval);
          recordingTime.value = '00:00';
        }

        mediaRecorder.mediaStreamSource.disconnect();
        mediaRecorder.recorder.disconnect();
        mediaRecorder.stream.getTracks().forEach(track => track.stop());

        const audioData = mergeBuffers(mediaRecorder.audioChunks);
        const wavBlob = createWavBlob(audioData, mediaRecorder.audioContext.sampleRate);
        const audioUrl = URL.createObjectURL(wavBlob);

        const reader = new FileReader();
        reader.readAsDataURL(wavBlob);
        reader.onloadend = () => {
          const base64data = reader.result;
          wav1.value = base64data;
          wav1Preview.value = audioUrl;
          finishChat();
        };

        mediaRecorder.audioContext.close();
        mediaRecorder = null;
      }
    };

    // 合并音频缓冲区
    const mergeBuffers = (buffers) => {
      const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
      const result = new Float32Array(totalLength);
      let offset = 0;
      buffers.forEach(buffer => {
        result.set(buffer, offset);
        offset += buffer.length;
      });
      return result;
    };

    // 创建WAV文件
    const createWavBlob = (audioData, sampleRate) => {
      const buffer = new ArrayBuffer(44 + audioData.length * 2);
      const view = new DataView(buffer);

      writeString(view, 0, 'RIFF');
      view.setUint32(4, 36 + audioData.length * 2, true);
      writeString(view, 8, 'WAVE');
      writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, 1, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, sampleRate * 2, true);
      view.setUint16(32, 2, true);
      view.setUint16(34, 16, true);
      writeString(view, 36, 'data');
      view.setUint32(40, audioData.length * 2, true);

      const floatTo16BitPCM = (output, offset, input) => {
        for (let i = 0; i < input.length; i++, offset += 2) {
          const s = Math.max(-1, Math.min(1, input[i]));
          output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
      };
      floatTo16BitPCM(view, 44, audioData);

      return new Blob([buffer], { type: 'audio/wav' });
    };

    // 写入字符串到DataView
    const writeString = (view, offset, string) => {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    };

    // 完成对话
    const finishChat = async () => {
      try {
        const id = route.params.id;
        if (id) {
            
          isPlaying.value = true;
          const response = await postData('chat_view_wav2txt', {
            audio: wav1.value,uuid
          });
          allChat.value.push({role:'user',content:response.data})
          setTimeout(() => {
            overFunc()
          }, 300);
        }
      } catch (error) {
        console.error('提交对话答案失败:', error);
      }
    };

    const autoStartRecording = async () => {
      isPlaying.value = 0;
      if (micPermissionGranted.value) {
        await startRecording();
        setTimeout(() => {
          if (recording.value) {
            stopRecording();
          }
        }, 90000);
      }
    };

    return {
      messages,
      recording,
      currentRound,
      wav1,
      wav1Preview,
      startRecording,
      stopRecording,
      recordingTime,
      micPermissionGranted,
      showRes,
      resView,
      resItem,
      showWelcome,
      startInterview,
      autoStartRecording,
      isPlaying,
      allChat,
      overFunc,
      isOver,
      isFinish,
      scrollbarRef,
      showRadarChart,
      scrollToBottom,
      showAudioSrc
    };
  }
};
</script>

<style scoped>
.radar-charts-container {
  display: block;

}

.radar-chart {
  flex: 1;
  height: 400px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
 
  margin: 40px 0;
}

.chat-container {
  height: 100vh;
  /* display: flex; */
  /* flex-direction: column; */
  /* background-color: #f5f7fa; */
  /* overflow: hidden; */
  padding-bottom: 110px;
  box-sizing: border-box;
}

.chat-main {
  /* flex: 1; */
  /* display: flex; */
  /* flex-direction: column; */
  position: relative;
  height: 100%;
}

.chat-history {
  flex: 1;
  overflow: hidden;
  padding: 16px;
  background-color: white;
  height: 100%;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message-bubble {
  max-width: 70%;
  padding: 12px;
  border-radius: 8px;
  margin: 8px 0;
  width: 70%;
}

.system-message {
  align-self: flex-start;
  background-color: #f2f2f2;
  border-radius: 8px 8px 8px 0;
}

.user-message {
  align-self: flex-end;
  background-color: #95ec69;
  border-radius: 8px 8px 0 8px;
}

.chat-input {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  padding: 16px;
  background-color: white;
  box-sizing: border-box;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.voice-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.voice-button {
  width: 48px;
  height: 48px;
  font-size: 20px;
}

.voice-hint {
  margin-top: 8px;
  color: #666;
  font-size: 12px;
  text-align: center;
}

.recording-time {
  margin-top: 4px;
  font-weight: bold;
  color: #409EFF;
}

.recorded-answer {
  text-align: center;
}

.processing-hint {
  color: #666;
  font-size: 12px;
  margin-top: 4px;
}

.welcome-screen {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.audio-playing-indicator {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 8px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: #409EFF;
  border-radius: 50%;
  animation: bounce 0.5s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-4px);
  }
}
</style>